/* eslint-disable import/prefer-default-export */
import * as lc from '../../../utils/lodashCustom';

export function restructurePaymentModel(data) {
  return {
    externalPaymentUrl: lc.get(data, 'external_payment_url')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/payment/restructuring/index.js